import * as actions from './actions'
import getters from './getters'
import mutations from './mutations'

const state = {
  memberList: {
    list: {
      data: [],
      total: 0,
    },
  },
  memberTree: {},
  tabsData: {
    data: [],
  },
  memberData: {
    data: {},
  },
  memberSearchData: {
    list: [],
  },
  memberMultiFunctionTreeData: {},
  memberRankList: {
    list: {
      data: {
        member: {},
        member_rank: [],
      },
    },
  },
  highestRankList: {
    list: [],
  },
  enrollmentRankList: {
    list: [],
  },
  memberMigrationList: {
    list: {
      data: {
        member: {},
        member_migrate: [],
      },
    },
  },
  memberStatusList: {
    list: {
      data: {
        member: {},
        member_status: [],
      },
    },
  },
  memberWalletTransactionList: {
    list: {
      data: [],
      total: 0,
    },
  },
  memberSalesHistoryList: {
    list: {
      data: [],
      total: 0,
    },
  },
  memberOnBehalfToken: {
    data: {},
  },
  memberSubscription: {
    data: {
      sale_id: 42018,
    },
  },
  memberNextPlacement: {
    data: {},
  },
  councilRankList: {
    list: [],
  },
  downlinePerformanceList: {
    list: {
      data: [],
      total: 0,
    },
  },
  memberSponsorDownlineListing: {
    list: {
      data: [],
      total: 0,
      details: {},
      dynamic_filters_total: [],
    },
  },
  memberSponsorDownlineListingFilters: {
    list: {
      data: [],
      total: 0,
    },
  },
}

export default {
  state,
  actions,
  mutations,
  getters,
}
